import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Fetcher } from '@this/src/util';
import { Loading } from '@this/shared/ui/feedbacks/loading';
import { Link } from '@this/components/shared/ui/navigations/link';
import { OrganizationBody, OrganizationTitle } from '@this/components/organization/organization.style';
import { InvoiceCustomFormatTitle } from '@this/components/organization/invoice_custom_formats/invoice_custom_formats.style';
import InvoiceCustomFormatForm from '@this/components/organization/invoice_custom_formats/invoice_custom_format_form';
import InvoiceCustomFormat from '@this/domain/invoice_custom_format/invoice_custom_format';
import type { InvoiceCustomFormatArgs } from '@this/domain/invoice_custom_format/invoice_custom_format';
import InvoiceStandardTable from '@this/src/domain/invoice_custom_format/invoice_standard_table';
import type { InvoiceStandardTableArgs } from '@this/src/domain/invoice_custom_format/invoice_standard_table';

interface Response {
  invoice_custom_format: InvoiceCustomFormatArgs;
  invoice_standard_tables: InvoiceStandardTableArgs[];
}

const InvoiceCustomFormatEdit = observer(() => {
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const [loading, setLoading] = useState(false);
  const [invoiceCustomFormat, setInvoiceCustomFormat] = useState<InvoiceCustomFormat | null>(null);
  const [invoiceStandardTables, setInvoiceStandardTables] = useState<InvoiceStandardTable[]>([]);

  const fetchInvoiceCustomFormat = async () => {
    setLoading(true);
    const response = await Fetcher.get<Response>(`/organization/invoice_custom_formats/${id}/edit.json`);
    setInvoiceCustomFormat(new InvoiceCustomFormat(response.invoice_custom_format));
    setInvoiceStandardTables(response.invoice_standard_tables.map(t => new InvoiceStandardTable(t)));
    setLoading(false);
  };

  useEffect(() => {
    fetchInvoiceCustomFormat();
  }, []);

  const handleEdit = () => {
    if (invoiceCustomFormat === null) return;
    setLoading(true);
    Fetcher.put(`/organization/invoice_custom_formats/${id}.json`, invoiceCustomFormat.submitParams())
      .then(() => {
        history.push('/organization/invoice_custom_formats');
      })
      .catch(e => {
        if (e.status === 400) {
          alert(e.responseJSON.errors);
        } else {
          alert('エラーが発生しました。');
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <OrganizationTitle>請求書・明細</OrganizationTitle>
      <OrganizationBody>
        <Link href="/organization/invoice_custom_formats">&lt; 戻る</Link>
        <InvoiceCustomFormatTitle>カスタムCSV編集</InvoiceCustomFormatTitle>
        {loading ? (
          <Loading />
        ) : (
          invoiceCustomFormat && (
            <InvoiceCustomFormatForm
              invoiceCustomFormat={invoiceCustomFormat}
              invoiceStandardTables={invoiceStandardTables}
              onSubmit={handleEdit}
            />
          )
        )}
      </OrganizationBody>
    </>
  );
});

export default InvoiceCustomFormatEdit;
